import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { IHistory } from '../../interfaces';
import { FlaggedFormModel } from '../../model/FlaggedFormModel';
import queryString from 'query-string';
import { inspectionType } from '../../constants/generals';

export interface IListItemProps {
    instance: FlaggedFormModel;
    index: number;
    location?: any;
    history: IHistory;
}

export class ListItemImpl extends React.Component<IListItemProps, {}> {

    static defaultProps: IListItemProps;

    render() {
        const category = queryString.parse(this.props.location.search).formType;
        const { instance, index, history } = this.props;
        return <Row className="form-list-item" >
            <ListItem category={category} sm={2} label={instance.props.PlantId}  {...this.props} />
            <ListItem category={category} sm={3} label={instance.props.Region}  {...this.props} />
            <ListItem category={category} sm={3} label={inspectionType(instance.props.type)}  {...this.props} />
            <ListItem
                category={category}
                sm={this.props.instance.props.CompletedBy || this.props.instance.props.CompletedBy === null
                    ? 2 : 4} label={instance.props.Date}  {...this.props} />
            {this.props.instance.props.CompletedBy || this.props.instance.props.CompletedBy === null ?
                <ListItem category={category}
                    sm={2}
                    label={instance.props.DateCompleted === 'None' ? 'NA' : instance.props.DateCompleted || 'NA'}
                    {...this.props}
                /> : ''}
        </Row>;
    }
}

export function mapStateToProps(state) {
    return {
        state
    };
}

const ListItem = ({ category, sm, label, history, instance }) => {
    return <Col

        onClick={() => history.push(`/flagged-forms/${category}/${instance.props.id}`)}
        className="clickable-list-item"
        xs={2}
        sm={sm}
    >
        {label || 'NA'}
    </Col>;
};

export const FlaggedListItem =
    withRouter(connect<{}, {}, IListItemProps>(mapStateToProps)(ListItemImpl as any));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/FlaggedForm/FlaggedFormListItem.tsx